import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import devAuth from "./modules/devAuth";
import snackbar from "./modules/snackbar";
import hrdc from "@/services/hrdc/store/hrdc";
import service from "./modules/service";
import developer from "./modules/developer";
import rolePermission from "./modules/rolePermission";
import parentSelectedModelValue from "./modules/parentSelectedModelValue";
import sessionExpired from "./modules/sessionExpired";
import modelDeleteDialog from "./modules/modelDeleteDialog";
import modelDetachDialog from "./modules/modelDetachDialog";
import modelEditDialog from "./modules/modelEditDialog";

Vue.use(Vuex);
const debug = process.env.VUE_APP_ENV !== "production";

import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";
const vuexCookie = new VuexPersistence({
  key: "cookieStore",
  restoreState: (key) => Cookies.get(key),
  saveState: (key, state) =>
    Cookies.set(key, state, {
      expires: 30, // expire in 30 days
    }),
});
const vuexLocal = new VuexPersistence({
  key: "localStore",
  storage: window.localStorage,
  modules: [
    //arrange in alphabetic order
    "auth",
    "devAuth",
    "developer",
    "hrdc",
    "snackbar",
    "service",
    "rolePermission",
    "parentSelectedModelValue",
  ],
});

export default new Vuex.Store({
  modules: {
    //arrange in alphabetic order
    auth,
    devAuth,
    developer,
    hrdc,
    modelDeleteDialog,
    modelDetachDialog,
    modelEditDialog,
    service,
    snackbar,
    sessionExpired,
    rolePermission,
    parentSelectedModelValue,
  },
  strict: debug,
  plugins: [vuexCookie.plugin, vuexLocal.plugin],
});
